import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { registerGlobalProperties } from './globalProperties'
import { registerPlugins } from './components/registerPlugins'
import { registerDirective } from './directive'
import { registerGlobComp } from '@/components/registerGlobComp'
import { setupStore } from '@/store'
import { setupRouterGuard } from '@/router/guard'
import './shims-core.d'

import 'normalize.css'
import 'swiper/css/bundle'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'

import 'swiper/css'
import 'swiper/css/free-mode'
import 'swiper/css/pagination'

import '@/assets/less/index.less'
import './app.less'

import 'virtual:uno.css'

// svg
import 'virtual:svg-icons-register'

async function bootstrap() {
  const app = createApp(App)

  // 配置 store
  setupStore(app)

  // 注册全局组件
  registerGlobComp(app)

  await registerPlugins(app)

  registerDirective(app)

  // globalProperties 全局方法
  registerGlobalProperties(app)

  setupRouterGuard(router)

  app.use(router)

  window._context = app._context

  app.config.errorHandler = (e) => {
    console.log('[error]', e)
  }

  app.mount('#app')
}

bootstrap()
